//
// Generated by @himenon/openapi-typescript-code-generator v0.27.4
//
// OpenApi : 3.0.0
//
//
import {
  Params$AdminStepController_findAll,
  Response$AdminStepController_findAll$Status$200,
  ResponseContentType$AdminStepController_findAll,
} from '@api-client/generated/client';
import { QueryOptions, useApiClient } from '@hooks/useApiClient';

export const useAdminStepController_findAll = (options: {
  params: Params$AdminStepController_findAll['parameter'];
  config?: QueryOptions<
    Response$AdminStepController_findAll$Status$200[ResponseContentType$AdminStepController_findAll]
  >;
}) =>
  useApiClient<
    Params$AdminStepController_findAll,
    Response$AdminStepController_findAll$Status$200[ResponseContentType$AdminStepController_findAll]
  >({
    method: 'AdminStepController_findAll',
    params: { parameter: options.params },
    config: options.config,
  });
